import { Moment } from "moment";
import React from "react";
import { DayPickerRangeController, FocusedInputShape } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import BB8Button from "./BB8Button";
import "./BB8DateRangePicker.scss";
export interface IBB8DateRangePickerProps {
  initialStartDate?: Moment;
  initialEndDate?: Moment;
  onDatesChange?: (startDate: Moment, endDate: Moment) => void;
  isActive: boolean;
  triggerComponent?: JSX.Element;
}

export interface IBB8DateRangePickerState {
  focusedInput: FocusedInputShape | null;
  startDate?: Moment;
  endDate?: Moment;
  shown: boolean;
}

export class BB8DateRangePicker extends React.Component<
  IBB8DateRangePickerProps,
  IBB8DateRangePickerState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      endDate: props.initialEndDate,
      focusedInput: "startDate" as FocusedInputShape,
      shown: false,
      startDate: props.initialStartDate
    };
  }

  public render() {
    const { focusedInput, startDate, endDate, shown } = this.state;

    const startDateString = startDate && startDate.format("MM/DD/YYYY");
    const endDateString = endDate && endDate.format("MM/DD/YYYY");

    const { isActive } = this.props;

    return (
      <div className="date-range-picker-container">
        {this.props.triggerComponent ?
          React.cloneElement(this.props.triggerComponent, {onClick: this.handleShowPicker})
        : (
          <BB8Button
            variant={isActive ? "contained" : "outlined"}
            className="date-range-picker-trigger"
            onClick={this.handleShowPicker}
            style={{ height: "48px" }}
          >
            {this.props.children}
          </BB8Button>
        )}
        {!shown ? null : (
          <div className={"date-range-picker-wrapper"}>
            <div className="date-range-picker-inputs">
              <span id="date-range-start-date">
                {startDateString || "start date"}
              </span>
              -
              <span id="date-range-end-date">
                {endDateString || "end date"}
              </span>
            </div>
            <div className="date-range-picker-content">
              <DayPickerRangeController
                isFocused={shown}
                startDate={startDate || null}
                endDate={endDate || null}
                onDatesChange={this.handleDateChange}
                focusedInput={focusedInput as FocusedInputShape}
                onFocusChange={this.handleFocusChange}
                numberOfMonths={2}
                noBorder={true}
                hideKeyboardShortcutsPanel={true}
                keepOpenOnDateSelect={true}
                verticalHeight={340}
              />
            </div>
            <div className="date-range-picker-footer">
              <BB8Button
                variant="outlined"
                color="default"
                onClick={this.handleCancel}
              >
                Cancel
              </BB8Button>
              <BB8Button
                variant="contained"
                color="primary"
                onClick={this.handleAppy}
              >
                Apply
              </BB8Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  private handleShowPicker = () => {
    this.setState({
      focusedInput: "startDate",
      shown: true
    });
  };

  private handleDateChange = ({
    startDate,
    endDate
  }: {
    startDate: Moment | null;
    endDate: Moment | null;
  }) => {
    this.setState({
      endDate: endDate ? endDate.endOf("day") : undefined,
      startDate: startDate ? startDate.startOf("day") : undefined
    });
  };

  private handleFocusChange = (focusedInput: FocusedInputShape | null) =>
    this.setState({ focusedInput });

  private handleAppy = () => {
    const { endDate, startDate } = this.state;
    if (endDate && startDate && this.props.onDatesChange) {
      this.setState(
        {
          shown: false
        },
        () => {
          this.props.onDatesChange!(startDate, endDate);
        }
      );
    }
  };

  private handleCancel = () => {
    this.setState(() => ({
      endDate: undefined,
      shown: false,
      startDate: undefined
    }));
  };
}

export default BB8DateRangePicker;
